import ReactQuill, { ReactQuillProps } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './styles.css';

export const RichText = (props: ReactQuillProps) => (
  <ReactQuill
    theme='snow'
    className='input'
    { ...props }
  />
);
